module.exports = __webpack_public_path__ + "static/media/main1.61d3d1f2.jpg";